import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="py-20 bg-mint-light" data-id="element-107">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-109">
          <p className="text-xl md:text-2xl leading-relaxed font-serif italic text-navy mb-8" data-id="element-110">
            "Estás frente a la pantalla. Lees la misma frase por quinta vez.
            Sabes lo que tienes que hacer, pero tu cerebro simplemente no
            responde. Te sientes lenta, pesada y frustrada."
          </p>
          <p className="text-lg md:text-xl text-navy/80 font-medium" data-id="element-111">
            No es falta de inteligencia. No es flojera. Es "Niebla Mental", y tu
            cerebro está operando en modo de emergencia porque está inflamado y
            sobreestimulado.
          </p>
        </motion.div>
      </div>
    </section>;
}